module.exports = __webpack_public_path__ + "static/img/planTextcb99ede.png";